class APIConsumer {
  api = "https://blackbarsgames.com/api";
  async login(username, password) {
    const responce = await fetch(this.api + "/login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        username: username,
        password: password,
      }),
    }).catch(() => {});
    const body = await responce.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
  async getMe(token) {
    console.log(token);
    const responce = await fetch(this.api + "/auth/me", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    }).catch((res) => {});
    const body = await responce?.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
  async getConsumers(token, q, page, sort) {
    const responce = await fetch(
      this.api +
        `/customer/get?q=${q ? q : ""}&page=${page ? page : ""}&sort=${
          sort ? sort : "id"
        }&size=10`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    const body = await responce?.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
  async getConsumer(token, id) {
    const responce = await fetch(this.api + `/customer/get/` + id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    });
    const body = await responce?.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
  formatDateToYYYYMMDD(dateq) {
    const date = new Date(dateq);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  async updateCostumerDate(token, id, date) {
    const responce = await fetch(this.api + `/customer/update/` + id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        expressedIn: this.formatDateToYYYYMMDD(date),
      }),
    });
    const body = await responce?.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
  async createCostumer(token, firstname, lastname, date, comment) {
    const responce = await fetch(this.api + `/customer/create`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        firstName: firstname,
        lastName: lastname,
        expressedIn: this.formatDateToYYYYMMDD(date),
        comment: comment,
      }),
    });
    const body = await responce?.json().catch((e) => null);
    if (!responce) return { status: 408 };
    return { status: responce.status, body: body };
  }
}
export default new APIConsumer();
